import React from 'react';
import { createRoot } from 'react-dom/client';
import { CircularProgress, Box } from '@mui/material';

import App from './App';
import AppInitWrapper from './components/AppInitWrapper';

import './index.scss';
import './styles/globals.css';
import './styles/overrides.css';

const container = document.getElementById('root');
const root = createRoot(container!);

// MUI Loading Spinner Component
const LoadingSpinner = () => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
    }}
  >
    <CircularProgress size={60} />
  </Box>
);

root.render(
    <React.StrictMode>
        <AppInitWrapper>
            <React.Suspense fallback={<LoadingSpinner />}>
                <App />
            </React.Suspense>
        </AppInitWrapper>
    </React.StrictMode>
);
